export default __webpack_public_path__ + "static/media/information--highway-interchange--g1.247302e7.png";